<div class="c-card c-card--height-fit">
	<div class="c-card__header">
		<div class="o-grid o-grid--top">
			<div class="o-grid__cell u-no-p">
				<p class="c-text">{{ 'Services.Other.Appointment' | translate }}: <span class="c-text c-text--bold">{{ vm.appointment.startDate }} {{ vm.appointment.scheduledStart | date:'HH:mm' }}</span></p>
			</div>
			<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
				<button id="cancelBookingButton{{vm.appointment.id}}" class="c-button c-button--link c-button--s4" (click)="vm.cancel()" [disabled]="!vm.isCancelAllowed()">{{ 'Common.Cancel' | translate }}</button>
			</div>
		</div>
	</div>
	<div class="o-media c-content">
		<div class="o-media__img">
			<div class="c-thumb">
				<avatar [user]="vm.appointment.service.user" [default]="'doctor'"></avatar>
				<div class="c-thumb__extra c-thumb__extra--sm">
					<item-status [status]="vm.appointment.service.user.status" [hasBorder]="true"></item-status>
				</div>
			</div>
		</div>
		<div class="o-media__body">
			<div class="o-grid o-grid--wrap">
				<div class="o-grid__cell o-grid__cell--slim u-no-p">
					<p class="c-text c-text--bold c-text--lg u-osb-xs">{{ vm.appointment.service.user.firstname }} {{ vm.appointment.service.user.lastname }}</p>
				</div>
				<div class="o-grid__cell o-grid__cell--w-fixed u-no-p u-ost-xs">
					<item-rating [model]="vm.appointment.userRating" [maxRating]="5" [size]="'sm'"></item-rating>
				</div>
			</div>
			<p class="c-text c-text--gray">{{ vm.appointment.service.occupation }}{{ (vm.appointment.service.parentServiceTitle) ? (', ' + vm.appointment.service.parentServiceTitle) : '' }}</p>
			<p class="c-text c-text--gray" *ngIf="vm.appointment.service.license">{{ vm.appointment.service.license }}</p>
		</div>
	</div>
	<div class="c-content c-content--footer">
		<div class="o-grid o-grid--wrap">
			<div class="o-grid__cell o-grid__cell--w-50 o-grid__cell--w-60@md-and-up u-no-p o-grid__cell--center-v">
				<div class="o-grid" *ngIf="vm.appointment.status!=='CONFIRMED'">
					<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
						<i class="o-icon o-icon--attention c-text c-text--main" aria-hidden="true"></i>
					</div>
					<div class="o-grid__cell o-grid__cell--slim">
						<p class="c-text c-text--main">{{ 'Services.Other.Waiting_Confirmation' | translate }}</p>
					</div>
				</div>
				<div class="c-notification c-notification--slim c-notification--s5" *ngIf="vm.appointment.timeLeftText && !vm.appointment.isExpired">
					<div class="o-grid">
						<div class="o-grid__cell">
							<p class="c-text" [innerHtml]="vm.appointment.timeLeftText"></p>
						</div>
					</div>
				</div>
			</div>
			<div class="o-grid__cell o-grid__cell--w-50 o-grid__cell--w-40@md-and-up u-no-p o-grid__cell--bottom">
				<div class="o-grid">
					<div class="o-grid__cell o-grid__cell--w-fixed@md-and-up o-grid__cell--slim o-grid__cell--right u-no-pr">
						<button class="c-button c-button--s3 c-button--narrow c-button--icon c-button--fit u-no-wrap" (click)="vm.openChat()"><i class="o-icon o-icon--chat" aria-hidden="true"></i> {{ 'Services.Button.Chat' | translate }}</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
